module.exports = __webpack_public_path__ + "img/Nasser_bin_Suleiman.29386de8.png";